<template>
  <div>
    <div class="mb-4">
      <div class="ui stackable middle aligned grid">
        <div class="eleven wide column">
          <div class="ui calendar toprow" id="rangestart">
            <div class="ui small input left icon">
              <i class="calendar icon"></i>
              <input :disabled="loading" type="text" ref="start_date" placeholder="开始日期">
            </div>
          </div>
          <div class="ui calendar toprow" id="rangeend">
            ~
            <div class="ui small input left icon">
              <i class="calendar icon"></i>
              <input :disabled="loading" type="text" ref="end_date" placeholder="结束日期">
            </div>
          </div>
          <div id="filter-dropdown" class="ui small basic teal dropdown button toprow">
            类型：
            <span v-if="!filter_op_type">全部</span>
            <span v-else>{{ op_name(filter_op_type) }}</span>
            <i class="dropdown icon"></i>
            <div class="menu">
              <div v-for="op in filter_op_types" :key="op" class="item" @click="filter_op_type=op"
                   :class="filter_button_class(op)">
                {{ op_name(op) }}
              </div>
            </div>
          </div>
          <button class="ui small teal button toprow load" :disabled="loading" @click="reload">
            查询
          </button>
        </div>
        <div class="five wide column">
          <div class="ui small fluid icon input toprow">
            <i class="search icon"></i>
            <input id="history-search" name="history-search" type="search" v-model="search_query" placeholder="按关键字搜索">
          </div>
        </div>
        
      </div>
    </div>

    <div v-if="search_query" class="ui basic teal label">
      匹配关键字： {{ search_query }}
      <a @click="search_query=''">
        <i class="times icon"></i>
      </a>
    </div>
    <table class="ui very basic stackable compact table">
      <tr v-for="(entry, index) in visible_entries" :key="index" class="entry">
        <td class="collapsing">
          <i class="blue clock icon"></i>
          {{ format_time(entry.time) }}
        </td>
        <td>
          <div v-for="(op, oi) in get_ops(entry.description)" :key="oi">
            <a @click="show_details(entry)" class="entry-desc">
              <span v-for="(t, i) in op.text" :key="i" :class="{ 'font-bold': i == 1 }">
                {{ t }}
              </span>
            </a>
            <br v-if="!screen_md">
            <template v-if="oi==0 && should_show_snapshot(entry)">
              <a class="quickaction ui mini basic teal button"
                 @click="open_snapshot(entry)">
                查看快照
              </a>
            </template>
            <a v-if="op.can_revert" class="quickaction ui mini basic teal button" @click="show_revert(index, op)">
              恢复文件
            </a>
          </div>
        </td>
      </tr>
    </table>
    <Placeholder v-if="loading" />
    <div v-else-if="!visible_entries.length" class="ui message">
     没有符合条件的数据 
    </div>
    <div class="my-4" v-if="!loading">
      <div v-if="total_pages > page">
        <button class="ui small teal basic button" @click="load_more">加载更多</button>
      </div>
      <div v-else>
        <button disabled class="ui small button">没有更多数据了</button>
      </div>
    </div>
    <Modal id="modal-browser" :title="browsing_title" hide_footer="true"  scrollable="true" class="fullscreen overlay" >
      <FileManager v-if="browsing_space" readonly title="根目录" :space="browsing_space" hide-tasks />
      <div v-else>
        <strong>
          {{ browsing_title }}
        </strong>
      <Placeholder class="mt-4" />
      </div>
    </Modal>
    <Modal id="modal-restore" title="恢复文件" scrollable="true" hide_footer="true">
      <template v-if="restore_state">
        <div>
          要恢复下面的文件到我的网盘吗？
          <ul class="my-6">
            <li class="restore-file" v-for="(rs, index) in restore_state.paths" :key="index">
              <i class="file icon"></i>
              {{ rs }}
            </li>
          </ul>
        </div>
        <div v-if="restore_state.log.length" class="ui segment">
          <div v-for="(log, index) in restore_state.log" :key="index">
            {{ log }}...
          </div>
          <div class="ui teal message" v-if="restore_state.done">
            <i class="check icon"></i>
            恢复成功
          </div>
          <div class="ui error message" v-if="restore_state.error">
            {{ restore_state.error }}
          </div>
        </div>
        <div v-if="restore_state.done || restore_state.error">
          <button class="ui small teal button" @click="hide_modal('modal-restore')">
            关闭
          </button>
        </div>
        <div v-else>
          <button class="ui small primary labeled icon button" :disabled="restore_state.busy" :class="{ loading: restore_state.busy }" @click="restore_files">
            <i class="check icon"></i>
            确认
          </button>
          <button class="ui small button" @click="hide_modal('modal-restore')">
            取消
          </button>
        </div>
      </template>
    </Modal>
    <Modal id="modal-details"
           :title="detail_entry?format_time(detail_entry.time):''"
           hide_footer="true" scrollable="true" ok-title="关闭">
      <template v-if="detail_entry">
        <div class="ui bulleted list">
          <div v-for="(op, index) in detail_entry.description" :key="index" class="item">
            <span v-for="(part, i) in op_text(op, false, false)" :key="i" class="mr-2">
              {{ part }}
            </span>
          </div>
        </div>
        <div class="ui segment" v-if="detail_entry.ip">
          <div v-if="detail_entry.ip">
            IP： {{ detail_entry.ip }}
          </div>
          <div v-if="detail_entry.location">
            GeoIP位置信息： {{ detail_entry.location }}
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from './modal.vue';
import Placeholder from './placeholder.vue';
import FileManager from './file-manager.vue';

export default {
  name: 'SpaceVersions',
  props: [],
  components: {
    FileManager,
    Placeholder,
    Modal,
  },
  data: function () {
    return {
      loading: false,
      entries: [],
      search_query: '',
      browsing_space: null,
      browsing_title: '',
      filter_op_type: null,
      restore_state: null,
      detail_entry: null,
      page: 0,
      total_pages: 0,
      start: null,
      end: null,
    };
  },
  computed: {
    start_date() {
      return this.$refs.start_date.value;
    },
    end_date() {
      return this.$refs.end_date.value;
    },
    filter_op_types() {
      return [null, 'delete', 'upload', 'rename', 'move', 'copy', 'mkdir', 'ingress'];
    },
    space() {
      return this.$store.state.space;
    },
    visible_entries() {
      if (!this.entries) {
        return [];
      }
      return this.entries.filter(x => {
        if (!this.should_show(x)) {
          return false;
        }
        var sq = this.search_query;
        var fo = this.filter_op_type;
        if (fo) {
          var ok = false;
          for (var op of x.description) {
            if (op.op == fo) {
              ok = true;
              break;
            }
          }
          if (!ok) {
            return false;
          }
        }
        if (!sq) {
          return true;
        }
        if (this.filter_search_query(sq, x)) {
          return true;
        }
        return false;
      });
    },
  },
  methods: {
    filter_search_query(sq, x) {
      if (sq.trim().length == 0) {
        return true;
      }
      for (var term of sq.split(" ").filter(k => k.trim().length)) {
        term = term.toLowerCase();
        var ok = false;
        for (var op of x.description) {
          if (op.path && op.path.toLowerCase().includes(term)) {
            ok = true;
          }
        }
        if (!ok) {
          return false;
        }
      }
      return true;
    },
    should_show(x) {
      if (!x.description.length) {
        return false;
      }
      if (x.description[0].path.startsWith('/.mods')) {
        return false;
      }
      return true;
    },
    op_text(op, last, simple) {
      var op_name = this.op_name(op.op);
      var path = op.path;
      var orig = op.orig;
      if (last) {
        if (path) {
          path = this.$store.state.space.path_last(path);
        }
        if (orig) {
          orig = this.$store.state.space.path_last(orig);
        }
      }
      switch (op.op) {
        case 'mkdir':
        case 'delete':
        case 'upload':
        case 'restore':
        case 'ingress':
          return [op_name, path];
        case 'move':
        case 'copy':
          if (simple) {
            return [op_name, orig];
          } else {
            return [op_name, orig, "→", path];
          }
        case 'rename':
          if (simple) {
            return [op_name, orig, "→", path];
          } else {
            return [op_name, orig];
          }
        case 'pwdata':
          return [op_name];
        case 'set-passphrase':
          return [op_name];
        default:
          return ["修改", path ? path : ""];
      }
    },
    show_details(entry) {
      this.detail_entry = entry;
      process.nextTick(this.show_modal.bind(this, 'modal-details'));
    },
    new_restore_state(entry, op) {
      return {
        entry: entry,
        paths: op.ops.map(x => x.path),
        log: [],
        busy: false,
        done: false,
        error: null,
      };
    },
    async restore_files() {
      var rs = this.restore_state;
      try {
        rs.busy = true;
        rs.log.push("正在打开历史快照");
        var space = this.$store.state.space;
        var sp = await this.client.open_space(this.space.name, this.$store.state.default_passphrase, rs.entry.root);
        for (var p of rs.paths) {
          var dp = space.path_last(p);
          rs.log.push("准备恢复" + dp);
          var c = await sp.fetch(p);
          if (!c) {
            throw new Error("无法找到数据: " + p);
          }
          var dirpath = space.dirname(p);
          await space.mkdir(dirpath);
          rs.log.push("正在恢复" + dp);
          await space.add_child(dirpath, c, 'restore', true);
          rs.log.push("成功恢复" + dp);
        }
        rs.done = true;
      } catch (e) {
        rs.error = this.error_text(e);
      } finally {
        this.restoring = false;
      }
    },
    async reload() {
      var start_date = this.$refs.start_date.value;
      var end_date = this.$refs.end_date.value;
      this.entries = [];
      this.page = 0;
      this.start = start_date ? Date.parse(start_date) : 0;
      this.end = end_date ?  Date.parse(end_date) + 86400000 : 0;
      this.load_more();
    },
    async load_more() {
      this.loading = true;
      var r = await this.client.fetch_space_history(this.space.name,
                                                    this.start, this.end, this.page);
      this.entries = this.entries.concat(r.entries);
      this.total_pages = r.pages;
      this.loading = false;
      if (this.total_pages > this.page) {
        this.page++;
      }
    },
    should_show_snapshot(entry) {
      for (var op of entry.description) {
        if (op.path) {
          return true;
        }
      }
      return false;
    },
    show_revert(index, op) {
      if (index >= this.entries.length - 1) {
        this.show_error("无法获取历史数据");
        return;
      }
      var entry = this.visible_entries[index + 1];
      this.restore_state = this.new_restore_state(entry, op);
      this.show_modal('modal-restore');
    },
    filter_button_class(t) {
      if (this.filter_op_type == t) {
        return ['teal'];
      } else {
        return ['basic', 'outline'];
      }
    },
    get_ops(d) {
      var op_groups = new Map();
      for (var op of d) {
        if (!op_groups.has(op.op)) {
          op_groups.set(op.op, []);
        }
        op_groups.get(op.op).push(op);
      }
      var ret = [];
      op_groups.forEach((ops, op) => {
        var text = this.op_text(ops[0], true, true);
        if (ops.length > 1) {
          text.push('等 (共' + ops.length + '个)');
        }
        ret.push({
          text: text,
          can_revert: op == 'delete',
          ops,
        });
      });
      return ret;
    },
    async open_snapshot(entry) {
      console.log("open snapshot", entry);
      this.browsing_space = null;
      this.browsing_title = "历史版本 - " + this.format_time(entry.time) + " [只读]";
      this.show_modal("modal-browser");
      try {
        var sp = await this.client.open_space(this.space.name, this.$store.state.default_passphrase, entry.root);
        this.browsing_space = sp;
      } catch (e) {
        this.show_error(e);
      }
    },
    op_name(op) {
      var ret;
      switch (op) {
        case 'mkdir':
          ret = "新建文件夹";
          break;
        case 'delete':
          ret = "删除";
          break;
        case 'move':
          ret = "移动";
          break;
        case 'copy':
          ret = "复制";
          break;
        case 'upload':
          ret = "上传";
          break;
        case 'rename':
          ret = "重命名";
          break;
        case 'restore':
          ret = "恢复";
          break;
        case 'ingress':
          ret = "文件闪传保存";
          break;
        case 'pwdata':
          ret = "密码管理器操作";
          break;
        case 'set-passphrase':
          ret = "修改加密密钥";
          break;
        case null:
          ret = "全部";
          break;
        default:
          ret = op ? op : "未知修改";
          break;
      }
      return ret;
    },
  },
  mounted() {
    this.reload();
    this.$("#filter-dropdown").dropdown({
      on: 'click',
    });
    this.$('#rangestart').calendar({
      type: 'date',
      firstDayOfWeek: 1,
      today: true,
      monthFirst: true,
      maxDate: new Date(),
      disableYear: true,
      endCalendar: this.$('#rangeend')
    });
    this.$('#rangeend').calendar({
      type: 'date',
      firstDayOfWeek: 1,
      today: true,
      monthFirst: true,
      maxDate: new Date(),
      disableYear: true,
      startCalendar: this.$('#rangestart')
    });

  },
}
</script>

<style scoped>
.entry {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #eee;
}
.quickaction {
  transition: opacity .25s ease-in-out;
}
.lg .quickaction {
  opacity: 0;
}
tr.entry:hover .quickaction {
  opacity: 1;
}
li.restore-file {
  margin-top: 0.5rem;
}
.toprow {
  display: inline-block;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}
.toprow.begin, .toprow.end {
  margin-left: 2rem !important;
}
.ui.calendar input {
  width: 130px;
}
#rangestart {
  margin-right: 5px !important;
}
#rangeend {
  margin-right: 10px !important;
}
.ui.button.load {
  margin-left: 10px !important;
}
.entry-desc {
  margin-right: 0.8rem;
}
</style>

